export default __webpack_public_path__ + "static/media/449.182d0d5c.jpg";